module.exports = __webpack_public_path__ + "img/logo-en.3b9af9b0.png";